import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2TargetWithArrowIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 21.933 24.16",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 24.16),
    children: [/*#__PURE__*/jsx("path", {
      d: "m10.093 11.838 4.134-4.134"
    }), /*#__PURE__*/jsx("path", {
      d: "m14.297 7.637.563-3.72 3.222-3.167.5 2.6 2.6.5-3.167 3.223z"
    }), /*#__PURE__*/jsx("path", {
      d: "m20.12 9.509a9.751 9.751 0 1 1 -8.444-7.222"
    }), /*#__PURE__*/jsx("path", {
      d: "m15.821 10.747a5.174 5.174 0 0 1 -2.256 5.625 5.355 5.355 0 0 1 -6.135-.27 5.163 5.163 0 0 1 -1.744-5.8 5.284 5.284 0 0 1 5-3.514"
    }), /*#__PURE__*/jsx("path", {
      d: "m5.57 20.274-.744 2.976"
    }), /*#__PURE__*/jsx("path", {
      d: "m16.079 20.274.744 2.976"
    })]
  });
};

export { PM2TargetWithArrowIcon };
//# sourceMappingURL=target-with-arrow.js.map
